import styled from 'styled-components';

import { cardBackround } from '@/styles/shared';

export const CardsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  margin-bottom: 24px;

  @media ${({ theme }) => theme.media.tablet} {
    grid-template-columns: repeat(3, 1fr);
    margin-bottom: 32px;
    gap: 24px;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;
`;

export const Wrapper = styled.div`
  padding: 20px 30px 30px 30px;
  ${cardBackround};

  h2 {
    font-size: 20px;

    @media ${({ theme }) => theme.media.tablet} {
      font-size: 24px;
    }
  }

  h3 {
    font-family: Roboto, Helvetica, sans-serif;
  }
`;
